export default {
      id: "oc-res-image-usage",
      viewBox: "0 0 1068 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-image",
      toString: function () {
        return this.url;
      }
    }